import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import { style } from "../../../components/pdf/fontstyles";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    marginLeft: 40,
    marginTop:40,
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 30, // Left and Right Margins for clean print layout
    fontSize: 10,
    ...style.marathi,
  },
  header: {
    textAlign: "center",
    marginBottom: 12,
    fontSize: 16,
    fontWeight: "bold",
    textDecoration: "underline",
  },
  table: {
    display: "table",
    width: "100%", // Stretch table across available width inside margins
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
    backgroundColor: "#f0f0f0",
    fontWeight: "bold",
    textAlign: "center",
  },
  tableCol: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
    textAlign: "center",
  },
  col1: { width: "5%" },   // Serial Number
  col2: { width: "20%" },  // Name and Designation
  col3: { width: "15%" },  // Qualification
  col4: { width: "10%" },  // Senior Pay Level
  col5: { width: "10%" },  // Recommendation
  col6: { width: "15%" },  // Leave Details
  col7: { width: "15%" },  // Confidential Report
  col8: { width: "10%" },  // Remarks
});


const Praptar3 = ({ result }) => (
 
    <View size="A4" style={styles.page}>
      <View style={styles.header}>
        <Text>प्रपत्र ३</Text>
      </View>

      <View style={styles.table}>
        {/* Table Header */}
        <View style={styles.tableRow}>
          <View style={[styles.tableColHeader, styles.col1]}>
            <Text>अ क्र</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col2]}>
            <Text>सेवकाचे नाव व हुद्दा</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col3]}>
            <Text>शैक्षणिक पात्रता</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col4]}>
            <Text>वरिष्ठ वेतन स्तर</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col5]}>
            <Text>शिफारस झाली आहे/नाही</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col6]}>
            <Text>बिनपगारी राजा तपशील</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col7]}>
            <Text>गोपनीय अहवाल सन...ते सन...</Text>
          </View>
          <View style={[styles.tableColHeader, styles.col8]}>
            <Text>शेरा</Text>
          </View>
        </View>

        {/* Table Row */}
        <View style={styles.tableRow}>
          <View style={[styles.tableCol, styles.col1]}>
            <Text>१</Text>
          </View>
          <View style={[styles.tableCol, styles.col2]}>
            <Text>{result.employeeName}</Text>
            <Text>{result.designation}</Text>
          </View>
          <View style={[styles.tableCol, styles.col3]}>
            <Text>{`<<QUALIFICATION>>`}</Text>
          </View>
          <View style={[styles.tableCol, styles.col4]}>
            <Text>{`<<SR PAY LEVEL>> :`}</Text>
            <Text>{`<<SR PAY SCALE>>`}</Text>
          </View>
          <View style={[styles.tableCol, styles.col5]}>
            <Text>नाही</Text>
          </View>
          <View style={[styles.tableCol, styles.col6]}>
            <Text>निरंक</Text>
          </View>
          <View style={[styles.tableCol, styles.col7]}>
            <Text></Text>
          </View>
          <View style={[styles.tableCol, styles.col8]}>
            <Text></Text>
          </View>
        </View>
      </View>
    </View>

);

export default Praptar3;